import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    venueClassId: '',
    User: {},
    permission: [],
    msgCount: {
      messages: 2
    },
    siderCollapsed: false,
    venueInfo: {}
  },
  mutations: {
    setVenueInfo(state, data) {
      state.venueInfo = data || {};
    },
    setVenueClassId(state, data) {
      state.venueClassId = data;
    },
    updateAccount(state, data) {
      state.User = data;
    },
    updatePermission(state, data) {
      state.permission = data;
    },
    updateSiderCollapse(state, isShow) {
      setTimeout(() => {
        G.trigger('page_resize');
      }, 600);
      state.siderCollapsed = isShow;
    },
    updateMsgCount(state, data) {
      state.msgCount = data;
    }
  },
  actions: {
    updateAccount(context, data) {
      context.commit('updateAccount', data);
    },
    updatePermission(context, data) {
      context.commit('updatePermission', data);
    },
    updateSiderCollapse(context, data) {
      context.commit('updateSiderCollapse', data);
    },
    updateMsgCount(context, data) {
      context.commit('updateMsgCount', data);
    },
  },
  getters: {
    venueInfo: state => {
      return state.venueInfo;
    },
    venueClassId: state => {
      return state.venueClassId;
    },
    account: state => {
      return state.User;
    },
    siderCollapsed: state => {
      return state.siderCollapsed;
    },
    msgCount: state => {
      return state.msgCount;
    }
  }
});
